import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { getNoticeDetail, NoticeDetailDto } from '../../api/deskApi';
import {formatDate} from "../../utils/format";

const NoticeDetailPage = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const [notice, setNotice] = useState<NoticeDetailDto | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (id) {
            fetchNoticeDetail(id);
        }
    }, [id]);

    const fetchNoticeDetail = async (code: string) => {
        try {
            setLoading(true);
            setError(null);
            const response = await getNoticeDetail(code);
            if (response.data?.data) {
                setNotice(response.data.data);
            } else {
                setError('공지사항을 불러오는데 실패했습니다.');
            }
        } catch (err) {
            console.error('Failed to fetch notice detail:', err);
            setError('공지사항을 불러오는데 실패했습니다.');
        } finally {
            setLoading(false);
        }
    };


    const handleFileDownload = (filePath: string, fileName: string) => {
        // 파일 다운로드 처리
        const link = document.createElement('a');
        link.href = filePath;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (loading) {
        return (
            <>
                <header className="sub-header">
                    <div className="header-inner">
                        <button type="button" className="backBtn" onClick={() => navigate(-1)}>
                            <span className="blind">뒤로가기</span>
                        </button>
                        <h1 className="subtitle">공지사항</h1>
                        <a href="/" className="homeBtn">
                            <span className="blind">홈으로</span>
                        </a>
                    </div>
                </header>
                <main className="container">
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        로딩 중...
                    </div>
                </main>
            </>
        );
    }

    if (error || !notice) {
        return (
            <>
                <header className="sub-header">
                    <div className="header-inner">
                        <button type="button" className="backBtn" onClick={() => navigate(-1)}>
                            <span className="blind">뒤로가기</span>
                        </button>
                        <h1 className="subtitle">공지사항</h1>
                        <a href="/" className="homeBtn">
                            <span className="blind">홈으로</span>
                        </a>
                    </div>
                </header>
                <main className="container">
                    <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
                        {error || '공지사항을 찾을 수 없습니다.'}
                    </div>
                </main>
            </>
        );
    }

    return (
        <>
            {notice.fileList && notice.fileList.length > 0 && (
                <div className="bottom-btn">
                    <ul className="file-wrap">
                        {notice.fileList.map((file) => (
                            <li key={file.seq}>
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleFileDownload(file.filePath, file.fileName);
                                    }}
                                >
                                    <p className="file-txt">
                                        <span className="file-tit">{file.fileName}</span>
                                        <span className="ico">
                                            <i className="fa-solid fa-file-arrow-down"></i>
                                        </span>
                                    </p>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            <main className="container">
                <section className="boardHeadline">
                    <div className="inner">
                        <p className="boardTitle">
                            {notice.isPinned === 'Y' && '[공지] '}
                            {notice.title}
                        </p>
                        <p className="boardDate">{formatDate(notice.regDate)}</p>
                    </div>
                </section>

                <section className="boardDetail">
                    <div className="inner">
                        <div
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notice.content) }}
                            style={{ whiteSpace: 'pre-wrap' }}
                        />
                    </div>
                </section>
            </main>
        </>
    );
};

export default NoticeDetailPage;